import React, { useMemo } from 'react'
import { withWindowSizeListener } from 'react-window-size-listener'
import { useHistory, useLocation } from 'react-router-dom'
import text from '../constants/Menu'
import { FiArrowLeft } from 'react-icons/fi'
import '../styles/containers/PerfilCarousel.css'
import Carousel from '../components/Carousel'
import useLanguage from '../hooks/useLanguage'

const PerfilCarousel = () => {
  const location = useLocation()
  const history = useHistory()

  const photos = useMemo(() => location.state && location.state.photos.map(image => ({ image })), [location.state])
  const initialPhoto = useMemo(() => location.state && location.state.initialPhoto, [location.state])
  const language = useLanguage()

  if (!photos) {
    history.replace('/perfil')
    return <div />
  }

  return (
    <div className='perfil-slide-container'>
      <div className='perfil-slide-title'>
        <FiArrowLeft onClick={() => history.goBack()}
          size={24} color='var(--primary)' className='perfil-slide-goback' />
        <p>{text.perfil[language]}</p>
      </div>
      <Carousel photos={photos} initialPhoto={initialPhoto} />
    </div>
  )
}

export default withWindowSizeListener(PerfilCarousel)



// WEBPACK FOOTER //
// ./src/containers/PerfilCarousel.js